/* eslint-disable */
import createIcon from '../createIcon';

const IconDownOutlined = createIcon({
  name: 'icon-down-outlined',
  content: '<path d="M511.681394 702.207841h0.637212l315.420037-315.420038-45.879278-45.242066L511.681394 611.723709 241.503423 341.545737l-45.242066 45.242066 315.420037 315.420038z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconDownOutlined;
